module.exports = __webpack_public_path__ + "img/news_on.dd8ac454.png";